"use client"

import React, { Fragment } from 'react'
import s from './errorPage.module.scss'
import cn from "classnames";
import {useTranslations} from "next-intl";


export const ErrorPageComponent = () => {

    const t = useTranslations('error_page');
    const reload = () => {
        window.location.reload();
    }

    return (
        <>
            <div className={s.error_page}>
                <div className={cn("container mx-auto", s.error_container)}>
                    <div className={s.d_flex}>
                        <div className={s.info_section}>
                            <h2 dangerouslySetInnerHTML={{ __html: t.raw('title') }} />
                            <div className={s.button}>
                                <button
                                    onClick={reload}
                                >
                                    {t('button')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}